import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { VariablesService } from '../../../shared/services';

@Component({
  selector: 'app-fundraiser-filter',
  templateUrl: './fundraiser-filter.component.html',
  styleUrls: ['./fundraiser-filter.component.scss']
})
export class FundraiserFilterComponent implements OnInit {

  filters = {};
  categoryValue: string;
  selectedFilter = 'category';
  appliedFilters;

  @Input() filterData;
  @Output() toggleFilterComponent = new EventEmitter<any>();

  constructor(
    private vars: VariablesService
  ) { }

  ngOnInit() { }

  /**Function to close the mobile filter component on click of X/Apply Filters */
  closeDialogFilter() {
    this.toggleFilterComponent.emit(false);
  }

  /**Function to toggle between different filters in the filter component */
  changeFilter(filter) {
    this.selectedFilter = filter;
  }

  /**Function for Reset Filter button on Mobile Filters */
  resetFilters() {
    this.vars.resetCounter.next(true);
    this.vars.resetFilter.next(true);
  }

}
